<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="journal-text" class="icon"></b-icon>
            <span>ข้อมูลร้านค้า</span>
            <button class="edit" @click="toggleEditStore()">
                <b-icon icon="pencil-fill"></b-icon>
            </button>
        </div>
        
        <div class="content">
            <div class="form" v-if="formData">
                <div class="row">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">ชื่อร้าน</label>
                    </div>
                    <div class="col-sm-12 col-md-9">
                        <div class="field">
                            <input type="text" 
                                    class="input-field"
                                    :class="{ 'reader': !isEditStore, 'invalid': errorData.name.blank }"
                                    maxlength="100"
                                    placeholder="ชื่อร้าน"
                                    v-model="formData.info.name"
                                    :readonly="!isEditStore" />
                            <div class="input-error-message" v-if="errorData.name.blank">โปรดกรอกชื่อร้าน</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">เลขประจำตัวผู้เสียภาษี</label>
                    </div>
                    <div class="col-sm-12 col-md-9">
                        <div class="field">
                            <input type="tel" 
                                    class="input-field" 
                                    :class="{ 'reader': !isEditStore, 'invalid': errorData.taxId.blank }"
                                    maxlength="20"
                                    placeholder="เลขประจำตัวผู้เสียภาษี"
                                    v-model="formData.info.taxId"
                                    :readonly="!isEditStore" />
                            <div class="input-error-message" v-if="errorData.taxId.blank">โปรดกรอกเลขประจำตัวผู้เสียภาษี</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">ที่อยู่</label>
                    </div>
                    <div class="col-sm-12 col-md-9">
                        <div class="field">
                            <input type="text"
                                    class="input-field"
                                    :class="{ 'reader': !isEditStore, 'invalid': errorData.address.blank }"
                                    maxlength="100"
                                    placeholder="ที่อยู่เลขที่/ซอย/ถนน"
                                    v-model="formData.info.address"
                                    :readonly="!isEditStore" />
                            <div class="input-error-message" v-if="errorData.address.blank">โปรดกรอกที่อยู่เลขที่</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-3"></div>
                    <div class="col-sm-12 col-md-4">
                        <div class="field">
                            <typeahead
                                ref="thaiAddressDataTumbon"
                                placeholder="แขวง/ตำบล"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.info.subDistrict"
                                :inputClass="['input-field', (isEditStore ? '' : 'reader'), (errorData.subDistrict.blank ? 'invalid' : '')]"
                                :readonly="!isEditStore"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'tumbon')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'tumbon')" />
                            <div class="input-error-message" v-if="errorData.subDistrict.blank">โปรดกรอกแขวง/ตำบล</div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <div class="field">
                            <typeahead
                                ref="thaiAddressDataAmphur"
                                placeholder="เขต/อำเภอ"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.info.district"
                                :inputClass="['input-field', (isEditStore ? '' : 'reader'), (errorData.district.blank ? 'invalid' : '')]"
                                :readonly="!isEditStore"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'amphur')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'amphur')" />
                            <div class="input-error-message" v-if="errorData.district.blank">โปรดกรอกเขต/อำเภอ</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-3"></div>
                    <div class="col-sm-12 col-md-4">
                        <div class="field">
                            <typeahead
                                ref="thaiAddressDataProvince"
                                placeholder="จังหวัด"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.info.province"
                                :inputClass="['input-field', (isEditStore ? '' : 'reader'), (errorData.province.blank ? 'invalid' : '')]"
                                :readonly="!isEditStore"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'province')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'province')" />
                            <div class="input-error-message" v-if="errorData.province.blank">โปรดกรอกจังหวัด</div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <div class="field">
                            <typeahead
                                ref="thaiAddressDataPostCode"
                                placeholder="รหัสไปรษณีย์"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.info.postCode"
                                :inputClass="['input-field', (isEditStore ? '' : 'reader'), (errorData.postCode.blank ? 'invalid' : '')]"
                                :readonly="!isEditStore"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'postcode')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'postcode')" />
                            <div class="input-error-message" v-if="errorData.postCode.blank">โปรดกรอกรหัสไปรษณีย์</div>
                        </div>
                    </div>
                </div>

                <div class="row field">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">ชื่อผู้มีอำนาจ/ผู้ติดต่อ</label>
                    </div>
                    <div class="col-sm-12 col-md-9">
                        <div class="field">
                            <input type="text"
                                    class="input-field"
                                    :class="{ 'reader': !isEditStore, 'invalid': errorData.owner.blank }"
                                    maxlength="100"
                                    placeholder="ชื่อผู้มีอำนาจ/ผู้ติดต่อ"
                                    v-model="formData.info.owner"
                                    :readonly="!isEditStore" />
                            <div class="input-error-message" v-if="errorData.owner.blank">โปรดกรอกชื่อผู้มีอำนาจ/ผู้ติดต่อ</div>
                        </div>
                    </div>
                </div>

                <div class="row field">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">เบอร์ติดต่อ</label>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <div class="field">
                            <input type="tel"
                                    class="input-field"
                                    :class="{ 'reader': !isEditStore, 'invalid': errorData.tel.blank }"
                                    maxlength="30"
                                    placeholder="ชื่อผู้มีอำนาจ/ผู้ติดต่อ"
                                    v-model="formData.info.tel"
                                    :readonly="!isEditStore" />
                            <div class="input-error-message" v-if="errorData.tel.blank">โปรดกรอกเบอร์ติดต่อ</div>
                        </div>
                    </div>
                </div>

                <div class="row field">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">LINE</label>
                    </div>
                    <div class="col-sm-12 col-md-4">
                        <div class="field">
                            <input type="text"
                                    class="input-field"
                                    :class="{ 'reader': !isEditStore }"
                                    maxlength="30"
                                    placeholder="@lineid"
                                    v-model="formData.info.line"
                                    :readonly="!isEditStore" />
                        </div>
                    </div>
                </div>

                <div class="row field">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">เว็บไซต์</label>
                    </div>
                    <div class="col-sm-12 col-md-9">
                        <div class="field">
                            <input type="text"
                                    class="input-field"
                                    :class="{ 'reader': !isEditStore }"
                                    maxlength="50"
                                    placeholder="https://..."
                                    v-model="formData.info.website"
                                    :readonly="!isEditStore" />
                        </div>
                    </div>
                </div>

                <div class="row field">
                    <div class="col-sm-12 col-md-3">
                        <label class="inline-label">facebook</label>
                    </div>
                    <div class="col-sm-12 col-md-9">
                        <div class="field">
                            <input type="text"
                                    class="input-field"
                                    :class="{ 'reader': !isEditStore }"
                                    maxlength="50"
                                    placeholder="https://www.facebook.com/xxx"
                                    v-model="formData.info.facebook"
                                    :readonly="!isEditStore" />
                        </div>
                    </div>
                </div>

                <div class="row field" v-if="isEditStore">
                    <div class="col-sm-12 col-md-3"></div>
                    <div class="col-sm-12 col-md-9">
                        <div class="mt-3">
                            <button class="btn btn-main" @click="saveStore()">บันทึก</button>
                            <button class="btn btn-grey-outline" @click="cancel()">ยกเลิก</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ThaiAddress from '@/resources/mixins/ThaiAddress';
import Helper from '@/resources/Helper';

export default {
    mixins: [ ThaiAddress],
    data() {
        return {
            isEditStore: false,
            displayData: null,
            formData: null,
            errorData: this.initValidateData()
        }
    },
    props: {
        fieldData: Object
    },
    watch: {
        fieldData(value) {
            this.setData(value);
        }
    },
    methods: {
        initValidateData() {
            return {
                name: { blank: false },
                taxId: { blank: false },
                address: { blank: false },
                subDistrict: { blank: false },
                district: { blank: false },
                province: { blank: false },
                postCode: { blank: false },
                owner: { blank: false },
                tel: { blank: false }
            }
        },
        toggleEditStore() {
            this.isEditStore = true;
        },
        setData(data) {
            this.displayData = data;
            this.formData = Helper.cloneObject(this.displayData);
        },
        saveStore() {
            if (this.validateData()) {
                this.isEditStore = false;
                this.displayData = Helper.cloneObject(this.formData);

                this.$emit('saveData', {
                    group: 'info',
                    data: this.displayData
                });
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (!this.formData.info[property].trim()) {
                    this.errorData[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        },
        cancel() {
            this.isEditStore = false;
            this.errorData = this.initValidateData();
            this.formData = Helper.cloneObject(this.displayData);
        }
    }
}
</script>